<!-- @format -->

<div class="hmf-sharp-radius hmf-p-m hmf-mt-s hmf-mt-m-m">
  <div
    id="valid-favorites"
    class="hmf-px-xxs hmf-px-m-0 hmf-grid favorites-card-container hmf-mb-l">
    @if (listData$()?.list) {
      @for (favProduct of currentProducts; track $index; let i = $index) {
        <div
          class="hmf-px-m-xxs hmf-col hmf-span-12 hmf-span-m-6 hmf-span-l-3 position-relative favorites-card">
          @if (!isPublicList()) {
            <shared-favorites-components-auth-icon
              class="favorites-icon"
              [ecode]="favProduct.ecode"
              [resolvedSku]="favProduct.sku"
              [location]="!isRecommendedList() ? FavoritesLocationEnum.FAVORITES : FavoritesLocationEnum.RECOMMENDED"
              [product]="favProduct"
              [listName]="listSignal().list.displayName"
              [isAuthenticated]="true"
              [listIndex]="i"
              (deleteProductEmit)="refreshPageAfterProductDelete()"
			        [disabled]="favoriteIconIsDisabled()">
            </shared-favorites-components-auth-icon>
          }
          @if (
            (favProduct.productAttributes | json) !== '{}') {
            <homefield-product-card
              id="product-card-{{ i }}"
              class="product-card"
              [chainAbbr]="getChainAbbr()"
              [seoUrl]="getProductUrl(favProduct, i)"
              [title]="favProduct.productAttributes.name"
              [badge]="favProduct.productAttributes.badge"
              [definingAttributes]="favProduct.productAttributes.definingAttributes"
              [colors]="getColors(favProduct.productAttributes)"
              [ecode]="favProduct.ecode"
              [sku]="favProduct.sku || ''"
              [mapPriceIndicator]="$safeNavigationMigration(favProduct.productAttributes.prices?.mapPriceIndicator)"
              [priceIndicator]="$safeNavigationMigration(favProduct.productAttributes.prices?.priceIndicator)"
              [prices]="favProduct.productAttributes.prices"
              [promo]="$safeNavigationMigration(promoMessages[favProduct.ecode]?.plpMessage)"
              [favoritesAttributes]="productAttributes.get(favProduct.id) || []"
              [referrer]="listReferrer"
              [productAvailabilityData]="$safeNavigationMigration(ecodeMessagingMap()?.[favProduct.ecode])"
              [productQuickViewEnabled]="true"
              [selectedStoreId]="selectedStoreId"
              [quickviewEnabled]="true"
              [recommendedAnalyticsData]="getRecommendedAnalyticsData(i)"
              (openAttributesPanelClicked)="toggleProductSidePanel($event, favProduct.id)"
              [inMauiList]="true"
						  [isCustomOrPersonalizedProduct]="checkIsCustomOrPersonalizedProduct(favProduct)"
              [location]="FavoritesLocationEnum.FAVORITES"
              [sharedList]="isSharedRoute()"
              [isRecommendedList]="isRecommendedList()"
              [oosListEnabled]="oosListEnabled"
              [productListID]="favProduct.id"
              (ecodeSelected)="openShopSimilarDrawer($event)"
              (openSkuResolvePanelEvent)="openSkuResolveDrawer($event)">
            </homefield-product-card>
          } @else {
            <homefield-product-card
              id="product-card-{{ i }}"
              class="product-card"
              [productAvailabilityData]="$safeNavigationMigration(ecodeMessagingMap()?.['UNAVAILABLE'])"
              [isUnavailable]="true"
              [inMauiList]="true"
              [isDisabled]="true">
            </homefield-product-card>
          }
        </div>
      }
    }
  </div>

  @if (!visualUpliftEnabled) {
    <shared-favorites-components-auth-non-store-pagination
      class="hmf-text-align-right"
      [itemLength]="totalCount"
      [(activePage)]="currentPage"
      (activePageChange)="determinePageUpdateEvent($event)">
    </shared-favorites-components-auth-non-store-pagination>
  } @else if (visualUpliftEnabled && showLoadMore) {
    <div id="load-more-container" class="hmf-col hmf-span-12 hmf-px-s-0 hmf-text-align-center">
      <hmf-button
        [variant]="'tertiary'"
        [text]="'Load More'"
        [classList]="'hmf-flex-grow hmf-mb-s hmf-span-3'"
        (click)="viewMoreProducts()"
        onkeypress="viewMoreProducts()">
      </hmf-button>
    </div>
  }

  <hmf-drawer
    #drawer
    [id]="'myaccount-favorites-side-panel'"
    direction="right"
    size="small"
    closeButtonVariant="tertiary"
    headerText="Review Your Customizations">
    <div
      ngProjectAs="customPanelBody"
      class="hmf-display-flex hmf-flex-column hmf-px-l hmf-mt-m hmf-body-s">
      <p class="hmf-mb-m hmf-subheader-bold-s label-base">{{ panelData?.productTitle }}</p>
      @for (attribute of panelData?.attributes; track attribute) {
        <p class="hmf-display-flex hmf-body-m label-base">
          <homefield-icon
            name="sign-circled-check-fill"
            width="16px"
            height="16px"
            class="hmf-mr-xxs">
          </homefield-icon>
          {{ attribute.title }}: {{ attribute.value }}
        </p>
      }
    </div>
  </hmf-drawer>
</div>

@if (showDSRecommendationsFP) {
  <div
    class="hmf-pt-xxl">
    <shared-components-ds-product-recommendations
      [eCodeList]="ecodesList"
      [eventType]="'detail-page-view'"
      [placementID]="'frequently-bought-together-high-diversity'"
      [containerID]="'Favorites_FBT'"
      [showViewAllLink]="true"
      [displayName]="'You May Also Like'"
      [pageType]="'List Contents'"
      [hideAddToCart]="false"
      [dsRecsDiversityLevel]="'no-diversity'"
      [customLinkID]="'YMAL'"
      [priceRerankLevel]="'high-price-reranking'"
      [capitalizeTitle]="true">
    </shared-components-ds-product-recommendations>
  </div>
}

@if (oosListEnabled) {
  <shared-components-drawer-product-recommendations
    drawerId="shop-similar-drawer"
    headerText="Shop Similar Items"
    filterBy="favorites_rr"
    [showVerticalLegacy]="true" />
}
